import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';
import { IAPIUser, Role } from '../../interfaces/user';
import { UsersService } from '../../../services/users.service';
import { CompanyService } from '../../../companies/company.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent implements OnInit {
  userPicture = '../../../assets/img/user-img.webp';
  user?: IAPIUser | null;
  selectedValue?: string | null;
  @Output() optionSelected = new EventEmitter<void>();
  protected readonly Role = Role;

  constructor(
    public router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    protected companyService: CompanyService,
  ) {
    this.selectedValue = this.companyService.selectedCompany();
  }

  selectCompany(event?: string) {
    this.companyService.selectCompany(event)
  }

  ngOnInit(): void {
    this.authService.authState$.subscribe(async () => {
      this.user = await this.usersService.me();
    });
  }

  async navigate(page: string) {
    await this.router.navigate([`/${page}`]);
    this.toggleSideBar();
  }

  logOut() {
    void this.authService.signOut();
  }

  toggleSideBar() {
    if (window.innerWidth < 768) this.optionSelected.emit();
  }
}
